//add color and bar padding properties
import { CommonSchemaIds } from "./common.const.js";
import { DataTableConfigurationSchemaIds, DataTableConfigurationTags } from "./configuration.const.js";
export const DATA_TABLE_CONFIGURATION_TLMD_SCHEMAS = {
    [DataTableConfigurationSchemaIds.DATA_TABLE_CONFIGURATION]: {
        id: DataTableConfigurationSchemaIds.DATA_TABLE_CONFIGURATION,
        schema: {
            unevaluatedProperties: false
        },
        properties: {
            visible: {
                ref: CommonSchemaIds.VISIBLE,
                required: true,
                usage: [{ tag: DataTableConfigurationTags.DEFAULT }]
            }
        }
    }
};
